import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Embers from "./Embers";

/**
 * Subpage hero header with breadcrumb + title + tagline + background image.
 */
export default function SubpageHero({
  title,
  tagline,
  eyebrow,
  image,
  crumb,
}) {
  return (
    <header
      data-testid="subpage-hero"
      className="relative w-full bg-pkcharcoal overflow-hidden pt-32 pb-20 sm:pt-40 sm:pb-28"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-pkcharcoal/55 via-pkcharcoal/65 to-pkcharcoal/90" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 25% 80%, rgba(217,4,41,0.3) 0%, transparent 55%)",
        }}
      />
      <div className="grain opacity-10" />
      <Embers count={14} />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-[0.65rem] sm:text-xs tracking-[0.3em] uppercase text-white/60 font-semibold">
          <Link
            to="/"
            data-testid="breadcrumb-home"
            className="hover:text-pkred transition-colors"
          >
            Pakkaland
          </Link>
          <ChevronRight className="w-3 h-3 text-pkred" strokeWidth={2} />
          <span className="text-white/85">{crumb}</span>
        </nav>

        {/* Eyebrow */}
        {eyebrow && (
          <div className="mt-10 flex items-center gap-3">
            <span className="block w-10 h-px bg-pkred shadow-[0_0_10px_rgba(217,4,41,0.8)]" />
            <span className="hero-fire-label text-pkred text-[0.65rem] sm:text-xs tracking-[0.4em] uppercase font-semibold">
              {eyebrow}
            </span>
          </div>
        )}

        {/* Title */}
        <h1
          data-testid="subpage-title"
          className="font-serif text-white text-5xl sm:text-6xl lg:text-[5.5rem] leading-[1.02] tracking-tight font-light mt-6 max-w-4xl"
        >
          {title}
        </h1>

        {tagline && (
          <p className="font-serif italic text-white/85 text-xl sm:text-2xl lg:text-3xl mt-8 max-w-3xl leading-snug font-light">
            {tagline}
          </p>
        )}
      </div>
    </header>
  );
}
